"use client";

import React, { createContext, useContext, useEffect, useState } from "react";

type ThemeMode = {
    mode: "light" | "dark",
    toggleMode: () => void
}
const ThemeContext = createContext<ThemeMode>({
    mode: "light",
    toggleMode: () => {}
});

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [mode, setMode] = useState<"light" | "dark">("light");

  useEffect(() => {
    let preference = localStorage.getItem("theme");

    if (preference == null) {
      if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
        preference = "dark";
      } else preference = "light";
    }
    if (preference === "dark") {
      setMode("dark");
    } else if (preference === "light") {
      setMode("light");
    }
  }, []);

  useEffect(() => {
    if (mode === "dark") {
      localStorage.setItem("theme", "dark");
      document.documentElement.classList.add("dark");
    }
    if (mode === "light") {
      localStorage.setItem("theme", "light");
      document.documentElement.classList.remove("dark");
    }
  }, [mode]);

  const toggleMode = () => {
    if (mode === "dark") {
        setMode("light")
    } else if (mode === "light") {
        setMode("dark")
    }
  }

  return (
    <ThemeContext.Provider value={{ mode, toggleMode}}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeMode = () => useContext(ThemeContext);
